import {
  FaNotesMedical,
  FaUserCheck,
  FaUserMd,
  FaUserNurse,
  FaUserPlus,
} from "react-icons/fa";
import { colors } from "../styles/colors";
import { rules } from "../utils/validation/Validation";

export enum ReAuthRequestActionDispatchTypes {
  REAUTH_REQUEST_INVOKE = "REAUTH_REQUEST_INVOKE",
  REAUTH_REQUEST_SUCCESS = "REAUTH_REQUEST_SUCCESS",
}

export enum PutAuthorizationDetailTabActionDispatchTypes {
  PUT_AUTHORIZATION_DETAIL_TAB_ERROR = "PUT_AUTHORIZATION_DETAIL_TAB_ERROR",
  PUT_AUTHORIZATION_DETAIL_TAB_INVOKE = "PUT_AUTHORIZATION_DETAIL_TAB_INVOKE",
  PUT_AUTHORIZATION_DETAIL_TAB_SUCCESS = "PUT_AUTHORIZATION_DETAIL_TAB_SUCCESS",
  PUT_AUTHORIZATION_DETAIL_TAB_RESET = "PUT_AUTHORIZATION_DETAIL_TAB_RESET",
}

export enum ReAuthTimelineActionDispatchTypes {
  GET_REAUTH_TIMELINE_INVOKE = "GET_REAUTH_TIMELINE_INVOKE",
  GET_REAUTH_TIMELINE_RESET = "GET_REAUTH_TIMELINE_RESET",
  GET_REAUTH_TIMELINE_SUCCESS = "GET_REAUTH_TIMELINE_SUCCESS",
}

export enum PatientSelectedAuthActionDispatchTypes {
  GET_PATIENT_SELECTED_AUTH_INVOKE = "GET_PATIENT_SELECTED_AUTH_INVOKE",
  GET_PATIENT_SELECTED_AUTH_SUCCESS = "GET_PATIENT_SELECTED_AUTH_SUCCESS",
}

export enum ServiceProviderDetailsActionDispatchTypes {
  GET_SERVICE_PROVIDER_DETAILS_INVOKE = "GET_SERVICE_PROVIDER_DETAILS_INVOKE",
  GET_SERVICE_PROVIDER_DETAILS_SUCCESS = "GET_SERVICE_PROVIDER_DETAILS_SUCCESS",
  GET_SERVICE_PROVIDER_DETAILS_RESET = "GET_SERVICE_PROVIDER_DETAILS_RESET",

  PUT_SERVICE_PROVIDER_DETAILS_ERROR = "PUT_SERVICE_PROVIDER_DETAILS_ERROR",
  PUT_SERVICE_PROVIDER_DETAILS_INVOKE = "PUT_SERVICE_PROVIDER_DETAILS_INVOKE",
  PUT_SERVICE_PROVIDER_DETAILS_SUCCESS = "PUT_SERVICE_PROVIDER_DETAILS_SUCCESS",
  PUT_SERVICE_PROVIDER_DETAILS_RESET = "PUT_SERVICE_PROVIDER_DETAILS_RESET",
 
  DELETE_SERVICE_PROVIDER_INVOKE = "DELETE_SERVICE_PROVIDER_INVOKE",
  DELETE_SERVICE_PROVIDER_SUCCESS = "DELETE_SERVICE_PROVIDER_SUCCESS",
  DELETE_SERVICE_PROVIDER_ERROR = "DELETE_SERVICE_PROVIDER_ERROR",
  DELETE_SERVICE_PROVIDER_RESET = "DELETE_SERVICE_PROVIDER_RESET"
}
export enum AuthorizationDetailTabsActionDispatchTypes {
  GET_AUTH_DETAIL_TABS_INVOKE = "GET_AUTH_DETAIL_TABS_INVOKE",
  GET_AUTH_DETAIL_TABS_SUCCESS = "GET_AUTH_DETAIL_TABS_SUCCESS",
  GET_AUTH_DETAIL_TABS_RESET = "GET_AUTH_DETAIL_TABS_RESET",
}

export enum ProviderListDefaultHeader {
  Action = "Action",
  NAME = "NAME",
  NPINumber = "NPI Number",
  NPI = "NPI",
  PROVIDER_NAME = "Name",
}

export enum ResumeIntakeActionDispatchTypes {
  RESUME_INTAKE_INVOKE = "RESUME_INTAKE_INVOKE",
  RESUME_INTAKE_RESET = "RESUME_INTAKE_RESET",
  RESUME_INTAKE_SUCCESS = "RESUME_INTAKE_SUCCESS",
}

export enum ReauthCompleteActionDispatchTypes {
  REAUTH_COMPLETE_ERROR = "REAUTH_COMPLETE_ERROR",
  REAUTH_COMPLETE_INVOKE = "REAUTH_COMPLETE_INVOKE",
  REAUTH_COMPLETE_SUCCESS = "REAUTH_COMPLETE_SUCCESS",
}

export const ActiveAuthorizationIcon = (label: string) => {
  switch (label) {
    case "Intake":
      return <FaUserPlus size={"1.2rem"} color={colors.fonts[18]} />;
    case "Clinical Review":
      return <FaNotesMedical size={"1.2rem"} color={colors.fonts[18]} />;
    case "Staffing":
      return <FaUserNurse size={"1.2rem"} color={colors.fonts[18]} />;
    case "Physician Review":
      return <FaUserMd size={"1.2rem"} color={colors.fonts[18]} />;
    case "NTU":
    case "Completed":
      return <FaUserCheck size={"1.2rem"} color={colors.fonts[18]} />;
  }
};

//Authorization Details

export enum AuthorizationDetailTitle {
  DIAGNOSIS_CODE = "DIAGNOSIS CODE",
  GENERAL_INFO = "GENERAL INFO",
  MEDICAL_HISTORY = "MEDICAL HISTORY",
  REQUEST_DETAILS = "REQUEST DETAILS",
}

export enum InitiateFaxActionDispatchTypes {
  POST_INITIATE_FAX_INVOKE = "POST_INITIATE_FAX_INVOKE",
  POST_INITIATE_FAX_SUCCESS = "POST_INITIATE_FAX_SUCCESS",
  POST_INITIATE_FAX_ERROR = "POST_INITIATE_FAX_ERROR",
  POST_INITIATE_FAX_RESET = "POST_INITIATE_FAX_RESET",
}

export const HeaderLabel = [
  { label: AuthorizationDetailTitle.GENERAL_INFO, fontWeight: 500 },
  { label: AuthorizationDetailTitle.DIAGNOSIS_CODE, fontWeight: 500 },
  { label: AuthorizationDetailTitle.MEDICAL_HISTORY, fontWeight: 500 },
  { label: AuthorizationDetailTitle.REQUEST_DETAILS, fontWeight: 500 },
];

export const AuthorizationDetailTabsInitialValue = {
  diseasesDto: [],
  psychologicalDiseasesDto: [],
  icdCodesInfoDto: [],
  authorizationGeneralInfoDto: null,
  requester: null,
  referralSource: null,
  originalIcdCodesInfoDto: null
};

export const GeneralInfoInitialValue = {
  receivedDate: null,
  receivedTime: null,
  authStatus: null,
  urgencySatus: null,
  urgencyReason: " ",
  referralSource: null,
  startOfCare: null,
  socValidate: false,
  staffingStatus: null,
  homeBound: null,
  homeBoundDate: null,
  careGiver: null,
  careGiverInfo: "",
  createdBy: "",
  createDate: null,
  effectiveFromDate: null,
  effectiveThroughDate: null,
  requestor: null,
  facilityDate: null,
  dischargeDate: null,
  dischargeReason: null,
  dischargeVerify: false,
};

export const UrgencyReasonTextLength = 2000;

export const AuthPastMedicalHistoryInitialValues = {
  diseasesDto: [],
  psychologicalDiseasesDto: [],
  referralId: null,
  userCreated: null,
};

export enum TimelineStagesStatusList {
  COMPLETED = "COMPLETED",
  REVIEW_PENDING = "Review Pending",
  START = "START",
  YET_TO_START = "Yet To Start",
}

export const TimelineStagesMessages = (value: string) => {
  switch (value) {
    case TimelineStagesStatusList.START:
      return "START";
    case TimelineStagesStatusList.REVIEW_PENDING:
      return "Review Pending";
    case TimelineStagesStatusList.YET_TO_START:
      return "Yet To Start";
    case TimelineStagesStatusList.COMPLETED:
      return "COMPLETED";
    default:
      return "";
  }
};

export enum PageStatus {
  RE_AUTH = "reauthRequest",
  CREATE_RECORD = "createRecord",
  PATIENT_DETAILS = "patientDetails",
}

//Always add in small case
export const StaffingStatusConstant = ["staffing automation", "tbd"];

export const requestorLabels = [
  {
    label: "Street Name 1: ",
    name: "requester.streetName1",
    helper: rules.streetName1,
    textLength: 100,
  },
  {
    label: "Street Name 2: ",
    name: "requester.streetName2",
    helper: rules.streetName2,
    textLength: 100,
  },
  {
    label: "County: ",
    name: "requester.county",
    helper: rules.county,
    textLength: 100,
  },
  {
    label: "City: ",
    name: "requester.city",
    helper: rules.cityRequired,
    textLength: 100,
  },
  {
    label: "State: ",
    name: "requester.requesterState",
    helper: rules.stateRequired,
    textLength: 100,
  },
  {
    label: "Zipcode: ",
    name: "requester.zipCode",
    helper: rules.zipcodeRequired,
    textLength: 10,
  },
];

export const referralSourceLabels = [
  {
    label: "Street Name 1: ",
    name: "referralSource.streetName1",
    helper: rules.streetName2,
    textLength: 100,
  },
  {
    label: "Street Name 2: ",
    name: "referralSource.streetName2",
    helper: rules.streetName2,
    textLength: 100,
  },
  {
    label: "County: ",
    name: "referralSource.county",
    helper: rules.county,
    textLength: 100,
  },
  {
    label: "City: ",
    name: "referralSource.city",
    helper: rules.city,
    textLength: 100,
  },
  {
    label: "State: ",
    name: "referralSource.referralSourceState",
    helper: rules.state,
    textLength: 100,
  },
  {
    label: "Zipcode: ",
    name: "referralSource.zipCode",
    helper: rules.zipcode,
    textLength: 10,
  },
];

export const NppesType = {
  PhysicianOffice: "1",
  Others: "2"
}

export const getNppesTypeDetails = (type: string) => {
  const nppesTypeDetails = { name: "lastName", placeHolder: "Enter Last Name", title: "Search by Name/State" };
  if (type !== NppesType.PhysicianOffice) {
    nppesTypeDetails.name = "organizationName";
    nppesTypeDetails.placeHolder = "Enter Organization Name";
    nppesTypeDetails.title = "Search by Organization Name/State"
  }
  return nppesTypeDetails;
}

export const WoundReviewTemplate = "Wound Review";